import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@/Components/Preferences/PreferencesComponents/Content';
import { observer } from 'mobx-react-lite';
import { c } from 'ttag';
const TwoFactorDescription = ({ auth }) => {
    if (!auth.isLoggedIn()) {
        return _jsx(Text, { children: c('B6.Preferences.Security.Info').t `Sign in or register for an account to configure 2FA.` });
    }
    return _jsx(Text, { children: c('B6.Preferences.Security.Info').t `An extra layer of security when logging in to your account.` });
};
export default observer(TwoFactorDescription);
